import React, { useEffect, useState } from "react";
import { Table, Typography } from "antd";
import { t } from "i18next";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useModal } from "../../../core/context/ModalContext";
import PaymentSummary from "../appointment-datagrid/PaymentSummary";
import { useUser } from "../../../core/context/UserContext";

const { Text } = Typography;

export const AppointmentAccountingSummary = () => {
    const { queryModel } = useDataGrid();
    const { openModal } = useModal();
    const { formatPrice } = useUser();
    const [summary, setSummary] = useState({
        appointmentSummaries: [],
        entitlementSummary: []
    });

    const openPaymentSummaryByMethod = () => {
        openModal(t('Summary'), (
            <PaymentSummary
                data={summary}
            />
        ))
    }

    const get = async () => {
        const input = {
            ...queryModel.filter,
            startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
            endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
        }

        const res2 = await ApiService.Appointment.GetAppointmentDataGridSummary(input);
        if (res2.success) {
            setSummary(res2.data)
        }
    }

    useEffect(() => {
        get()
    }, [queryModel.updateKey])

    if (!summary?.appointmentSummaries || summary.appointmentSummaries.length === 0) {
        return null;
    }

    return (
        <Table.Summary fixed>
            <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>

                {/* 1. Boşluk ve Başlık (İlk 7 kolonu kaplar ve sağa yaslı yazı yazar) */}
                <Table.Summary.Cell index={0} colSpan={9} align="right">
                    <Text strong style={{ marginRight: 8 }}>{t('General Total')}:</Text>
                </Table.Summary.Cell>

                {/* 2. Toplam Fiyat (Price Column) */}
                <Table.Summary.Cell index={1} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.appointmentSummaries.map((s, i) => (
                            <Text key={i} type="secondary" style={{ fontSize: 12, display: 'block' }}>
                                {formatPrice(s.totalPrice, { currency: s.currency })}
                            </Text>
                        ))}
                    </div>
                </Table.Summary.Cell>

                {/* 3. Toplam Ödenen (Paid Column) */}
                <Table.Summary.Cell index={2} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.appointmentSummaries.map((s, i) => (
                            <a
                                key={i}
                                onClick={openPaymentSummaryByMethod}
                                style={{ fontWeight: 600, color: '#1890ff', display: 'block', fontSize: 12 }}
                            >
                                {formatPrice(s.totalPaid, { currency: s.currency })}
                            </a>
                        ))}
                    </div>
                </Table.Summary.Cell>

                {/* 4. Toplam Bakiye (Balance Column) */}
                <Table.Summary.Cell index={3} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.appointmentSummaries.map((s, i) => (
                            <Text
                                key={i}
                                strong
                                style={{
                                    display: 'block',
                                    color: s.total > 0 ? '#cf1322' : '#389e0d', // Borç varsa kırmızı, yoksa yeşil
                                    fontSize: 13
                                }}
                            >
                                {formatPrice(s.total, { currency: s.currency })}
                            </Text>
                        ))}
                    </div>
                </Table.Summary.Cell>

            </Table.Summary.Row>
        </Table.Summary>
    )
}